import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { IProductItem } from '@core/models/interfaces/product/product-item.interface';
import { IProductType } from '@core/models/interfaces/product/product-type.interface';
import { ProductItem } from '@core/models/results/product-item.model';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  url = `${environment.endpoint.api}/product`;

  constructor(private httpClient: HttpClient) {}

  getProductsByType(type: number): Observable<ProductItem[]> {
    return this.httpClient
      .get<IProductItem[]>(`${this.url}/${type}`)
      .pipe(
        map((response: IProductItem[]) =>
          response.map((product: IProductItem) => new ProductItem(product))
        )
      );
  }

  getCurrentProduct(): Observable<IProductItem> {
    return this.httpClient.get<IProductItem>(`${this.url}/current`);
  }

  getProductTypes(): Observable<IProductType[]> {
    return this.httpClient.get<IProductType[]>(`${this.url}/types`);
  }
}
